import React from "react";
import Input from "../../../../../Components/Common/Input";
import HtmlEditor from "../../../../../Components/Common/HtmlEditor";
import ImageSelector from "../../../../../Components/Common/ImageSelector";

const FooterPageForm = ({ onChange, handleSubmit, errors, formData, setModalOpen }) => {
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Title"
        type="text"
        name="title"
        value={formData.title}
        onChange={onChange}
        placeholder="Enter page title"
        error={errors.title}
        required
      />
      <Input
        label="Slug"
        type="text"
        name="slug"
        value={formData.slug}
        onChange={onChange}
        placeholder="Enter page slug"
        error={errors.slug}
        required
      />
      <HtmlEditor
        label="Description"
        name="description"
        value={formData.description}
        onChange={onChange}
        error={errors.description}
        placeholder="Enter page content"
      />
      <ImageSelector
        label="Featured Image"
        name="featuredImage"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.featuredImage}
        placeholder="Click to select an image"
        error={errors.featuredImage}
      />
    </form>
  );
};

export default FooterPageForm;
